import React from "react";
import { PageHero } from "../components/PageShells";
import { Sparkles, Users, Map, Trophy } from "lucide-react";

const stats = [
  { icon: Users, value: "2.500+", label: "Klanten geholpen" },
  { icon: Map, value: "12", label: "Provincies actief" },
  { icon: Trophy, value: "98%", label: "Klanttevredenheid" },
  { icon: Sparkles, value: "Sinds 2016", label: "Actief in de energiemarkt" },
];

const OverOns = () => (
  <main data-testid="about-page">
    <PageHero
      eyebrow="Over ons"
      title="Gedreven door een slimme oplossing voor de energiemarkt."
      subtitle="De oprichter van Helios Bright is sinds 2016 actief binnen de zonne-energie- en energiemarkt. Vanuit jarenlange ervaring helpen wij particulieren en bedrijven met slimme energieoplossingen die verder gaan dan alleen zonnepanelen."
      image="https://customer-assets.emergentagent.com/job_solar-power-next/artifacts/fqn3bkhe_804c598f-870c-4037-972a-9d8480be24fa.png"
    />
    <section className="section-pad">
      <div className="max-w-6xl mx-auto px-5 lg:px-8 grid md:grid-cols-4 gap-5">
        {stats.map((s) => (
          <div key={s.label} className="bg-white rounded-3xl border border-slate-200 p-7 text-center">
            <s.icon className="mx-auto text-brand mb-3" size={28} />
            <div className="font-heading font-black text-4xl text-navy-900">{s.value}</div>
            <div className="text-sm text-slate-500 mt-1">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
    <section className="section-pad bg-slate-50/70">
      <div className="max-w-3xl mx-auto px-5 lg:px-8">
        <h2 className="font-heading text-4xl font-black text-navy-900 mb-6 text-balance">Ons verhaal</h2>
        <div className="space-y-5 text-slate-700 text-lg leading-relaxed">
          <p>
            De oprichter van Helios Bright is sinds 2016 actief binnen de zonne-energie, en energiemarkt. Door jarenlang de ontwikkelingen in de branche te volgen, werd steeds duidelijker dat zowel particulieren als bedrijven behoefte hebben aan slimme energieoplossingen die verder gaan dan alleen zonnepanelen.
          </p>
          <p>
            Met het afbouwen van de salderingsregeling, stijgende energiekosten en de toenemende druk op het energienet groeide de vraag naar oplossingen waarmee klanten meer uit hun eigen energie kunnen halen. Vanuit die visie is Helios Bright ontstaan.
          </p>
          <p>
            Onze missie is eenvoudig: huishoudens en ondernemers helpen hun energiekosten te verlagen, slimmer om te gaan met energie en meer controle te krijgen over hun eigen verbruik. Met oplossingen zoals thuisbatterijen, zonnepanelen en laadpalen maken we verduurzamen begrijpelijk, toegankelijk en financieel aantrekkelijk.
          </p>
          <p>
            Of het nu gaat om een woning, bedrijfspand of wagenpark, wij kijken naar de situatie en adviseren een oplossing die past bij de wensen én het budget van de klant.
          </p>
          <p>
            Geen ingewikkelde verhalen of agressieve verkoop. Gewoon eerlijk advies, hoogwaardige systemen en een oplossing waar je jarenlang op kunt vertrouwen.
          </p>
          <p className="font-heading font-bold text-navy-900 text-xl pt-2">
            Meer controle. Lagere energiekosten. Slimmer omgaan met energie.
          </p>
        </div>
      </div>
    </section>
  </main>
);

export default OverOns;
